import { subjectId } from '../fixture-ids';

export const userEntries = {
  // No `users` row exists yet at invite time, so entity: null -- an invitation is not a DB record
  // this map tracks.
  USER_INVITED: {
    entity: null,
    identity: 'event',
    renderMode: 'keyValue',
    createsRecord: false,
  },
  USER_DELETED: {
    entity: 'user',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: false,
  },
  // No special case: oldRole/newRole each render as their own diffed field row, per the
  // uniform resolver -- do not synthesize a single-row before/after from the two keys.
  USER_ROLE_EDITED: {
    entity: 'user',
    identity: 'record',
    idKeys: ['subjectId'],
    renderMode: 'diff',
    createsRecord: false,
  },
};

export const userFixtures = {
  USER_INVITED: {
    action: 'USER_INVITED',
    debugData: { email: 'new.hire@example.com', roleName: 'Integration Manager', invitationId: 'inv_9f8a7b6c5d4e' },
  },
  USER_DELETED: {
    action: 'USER_DELETED',
    debugData: { id: subjectId, email: 'former.employee@example.com', name: 'Former Employee' },
  },
  USER_ROLE_EDITED: {
    action: 'USER_ROLE_EDITED',
    debugData: {
      subjectId,
      email: 'teammate@example.com',
      oldRole: 'Editor',
      newRole: 'Admin',
    },
  },
  // Current generation: displayRoleName's own fallback (audit.go:133-138, covered by
  // audit_test.go:418-420). A first-ever role assignment renders oldRole as the literal string
  // 'no role' -- a present value, never normalized.
  USER_ROLE_EDITED_NO_PRIOR_ROLE: {
    action: 'USER_ROLE_EDITED',
    debugData: {
      subjectId,
      email: 'brand.new@example.com',
      oldRole: 'no role',
      newRole: 'Read-Only',
    },
  },
};
